export default __webpack_public_path__ + "static/media/right-two.db679f63.png";